
 export default class common  {
	 static organization(data,orglevel){
		 let arr = {}
		if(orglevel==1){
			if(data.length == 0){
				arr.shengjiId = ''
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length ==1){
				arr.shengjiId = data[0]
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length == 2){
				arr.shengjiId = data[1]
				arr.shijiId = data[0]
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length == 3){
				arr.shengjiId = data[2]
				arr.shijiId = data[1]
				arr.qujiId = data[0]
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length == 4){
				arr.shengjiId = data[3]
				arr.shijiId = data[2]
				arr.qujiId = data[1]
				arr.stationId = data[0]
				arr.shequjiId = ''
			}else if(data.length == 5){
				arr.shengjiId = data[4]
				arr.shijiId = data[3]
				arr.qujiId = data[2]
				arr.stationId = data[1]
				arr.shequjiId =  data[0]
			}
		}

		if(orglevel==2){
			if(data.length == 0){
				arr.shengjiId = ''
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId =  ''
			}else if(data.length ==1){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = data[0]
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId =  ''
			}else if(data.length == 2){
				arr.shengjiId =JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = data[1]
				arr.qujiId = data[0]
				arr.stationId = ''
				arr.shequjiId =  ''
			}else if(data.length == 3){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = data[2]
				arr.qujiId = data[1]
				arr.stationId = data[0]
				arr.shequjiId =  ''
			}else if(data.length == 4){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = data[3]
				arr.qujiId = data[2]
				arr.stationId = data[1]
				arr.shequjiId =  data[0]
			}else if(data.length == 5){
				arr.shengjiId = data[4]
				arr.shijiId = data[3]
				arr.qujiId = data[2]
				arr.stationId = data[1]
				arr.shequjiId =  data[0]
			}
		}

		if(orglevel==3){
			if(data.length == 0){
				arr.shengjiId = ''
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId =  ''
			}else if(data.length ==1){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId =  data[0]
				arr.stationId = ''
				arr.shequjiId =  ''
			}else if(data.length == 2){
				arr.shengjiId =JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId = data[1]
				arr.stationId = data[0]
				arr.shequjiId =  ''
			}else if(data.length == 3){
				arr.shengjiId =JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId = data[2]
				arr.stationId = data[1]
				arr.shequjiId =  data[0]
			}
		}

		if(orglevel==4){
			if(data.length == 0){
				arr.shengjiId = ''
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length ==1){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId =  JSON.parse(localStorage.getItem('czUserInfo')).qujiId
				arr.stationId = data[0]
				arr.shequjiId = ''
			}else if(data.length ==2){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId =  JSON.parse(localStorage.getItem('czUserInfo')).qujiId
				arr.stationId = data[1]
				arr.shequjiId = data[0]
			}
			
		}
		
		if(orglevel==5){
			if(data.length == 0){
				arr.shengjiId = ''
				arr.shijiId = ''
				arr.qujiId = ''
				arr.stationId = ''
				arr.shequjiId = ''
			}else if(data.length ==1){
				arr.shengjiId = JSON.parse(localStorage.getItem('czUserInfo')).shengjiId
				arr.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
				arr.qujiId =  JSON.parse(localStorage.getItem('czUserInfo')).qujiId
				arr.stationId = JSON.parse(localStorage.getItem('czUserInfo')).stationId
				arr.shequjiId = data[0]
			}
		}
		 return arr
   }
   	 // 手机
	 static phone(val){
		return  /^1[3|4|5|6|7|8|9]\d{9}$/.test(val)
	 }
	 // 姓名
	 static name(val){
	 		return  /^[\u4e00-\u9fa5]{1,50}$/.test(val)
	 }
	 // 身份证号
	 static idCard(val){
	 		return   /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(val)
	 }
	 
 }